import { useState } from 'react'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/common/ui/dialog'
import { Button } from '@/common/ui/button'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import useMutationCreateProfilePageBanner from '@/modules/client-setting/api/hooks/useMutationCreateProfilePageBanner'
import { ProfilePageBannerQueryKeys } from '@/modules/client-setting/keys'
import ProfilePageBannerForm, {
	ProfilePageBannerFormValues,
} from '../../../ProfilePageBannerForm'

export default function CreateProfilePageBannerModal() {
	const [open, setOpen] = useState(false)
	const { mutate: createProfilePageBanner } =
		useMutationCreateProfilePageBanner()
	const queryClient = useQueryClient()

	const onSubmit = (data: ProfilePageBannerFormValues) => {
		const payload = {
			title: data.title,
			image: data.image,
			type: data.type,
			link: data.type === 'LINK' ? data.link : undefined,
			gameCode: data.type === 'GAME' ? data.gameCode : undefined,
			isActive: data.isActive,
		}

		createProfilePageBanner(
			{ payload },
			{
				onSuccess: () => {
					toast.success('เพิ่มปุ่มทางเข้าเกมสำเร็จ')
					setOpen(false)
					queryClient.invalidateQueries({
						queryKey: [ProfilePageBannerQueryKeys.GetProfilePageBanners],
					})
				},
				onError: (error) => {
					showErrorToast(error)
				},
			},
		)
	}

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger asChild>
				<Button variant="default">เพิ่มปุ่มทางเข้าเกม</Button>
			</DialogTrigger>
			<DialogContent className="max-h-[100vh] overflow-y-auto sm:max-w-[600px]">
				<DialogHeader>
					<DialogTitle>เพิ่มปุ่มทางเข้าเกม</DialogTitle>
				</DialogHeader>
				<div className="max-h-[calc(100vh-120px)] overflow-y-auto">
					<ProfilePageBannerForm
						onSubmit={onSubmit}
						submitButtonText="เพิ่มปุ่ม"
					/>
				</div>
			</DialogContent>
		</Dialog>
	)
}
